import base from './base.repository';

export default {
    ...base,
    loadRiskAnalysis(filters, page){
        const params = {...filters, page: page};
        this.get(`risk-analysis${this.querify(params)}`);
        return this;
    },
    loadAuthorsByClient(clientId){
        this.get(`risk-analysis/authors?client=${clientId}`);
        return this;
    },
    saveRiskAnalysis(riskAnalysis) {
        this.post(`risk-analysis`, riskAnalysis);
        return this;
    },
    deleteRiskAnalysis(id){
        this.delete('risk-analysis/'+ id);
        return this;
    }
}